export default "__VITE_ASSET__Dr$P6Ct4__"